import { render, staticRenderFns } from "./AdComponent.vue?vue&type=template&id=ae4dc2c2&scoped=true"
import script from "./AdComponent.vue?vue&type=script&lang=js"
export * from "./AdComponent.vue?vue&type=script&lang=js"
import style0 from "./AdComponent.vue?vue&type=style&index=0&id=ae4dc2c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4dc2c2",
  null
  
)

export default component.exports